/* Court Vibes, 20.09.2026. Waechter fuer das Mengenfeld von teeinblue.

   WARUM ES DAS GIBT
   Houda hat am 20.09.2026 ein Bildschirmfoto vom Handy geschickt: neben dem
   Kaufknopf stand im Mengenfeld nicht die Zahl 1, sondern der graue englische
   Platzhalter "Qty". Der Fehler liess sich danach nicht mehr erzeugen, weder
   bei ihr noch bei mir. Ein Fehler, den man nicht reproduzieren kann, ist
   trotzdem ein Fehler, und beim Kunden waere er richtig unangenehm.

   WAS GEMESSEN WURDE, am 20.09.2026 auf /products/vereins-trikot:
   - teeinblue fuehrt die Menge in seinem EIGENEN Speicher, nicht im Feld.
     Probe: Feld von Hand geleert, dann Plus getippt. teeinblue zaehlte von
     seiner internen 2 auf 3 weiter, das leere Feld war ihm egal.
   - Das Feld ist also nur eine Anzeige. Es kann leer sein, ohne dass die
     Bestellmenge falsch waere.
   - Am Desktop steht direkt nach dem Laden eine 1 darin, am Handy stand nichts.

   WAS DIESE DATEI TUT
   Sie fuellt eine 1 ein, WENN das Feld leer ist UND der Kunde die Menge noch
   nicht angefasst hat. Direkt nach dem Laden steht teeinblues interne Menge
   nachweislich auf 1, dort koennen Anzeige und interner Stand also nicht
   auseinanderlaufen. Sobald der Kunde einmal auf Plus, Minus oder das Feld
   tippt, haelt sich der Waechter fuer den Rest der Seite komplett heraus. Er
   kann damit NIE eine Kundeneingabe ueberschreiben.

   Zusaetzlich wird der Platzhalter von "Qty" auf "Menge" gesetzt. Englisch hat
   in einem deutschen Shop dort nichts verloren, und falls das Feld doch einmal
   leer bleibt, steht wenigstens ein deutsches Wort da.

   WAS SIE BEWUSST NICHT TUT
   Sie schreibt nie einen anderen Wert als 1, sie ueberschreibt nie einen
   vorhandenen Wert, und sie fasst teeinblue selbst nicht an. Faellt diese
   Datei aus, ist alles genau wie vorher.

   Probe im Browser:
   getComputedStyle(document.documentElement).getPropertyValue('--cv-menge') */

(function () {
  var FELD = '.tee-quantity-group .tee-quantity-input';
  var GRUPPE = '.tee-quantity-group';
  var TAKT = 300;
  var FENSTER = 12000;
  var PLATZHALTER = 'Menge';

  var angefasst = false;
  var anstossTimer = null;

  function feld() {
    return document.querySelector(FELD);
  }

  /* Nur die Beschriftung. Das ist immer ungefaehrlich und darf deshalb auch
     nach einer Kundeneingabe noch laufen. */
  function beschriften(inp) {
    if (inp.getAttribute('placeholder') !== PLATZHALTER) {
      inp.setAttribute('placeholder', PLATZHALTER);
    }
  }

  /* Die 1 nur dann, wenn wirklich nichts drinsteht und der Kunde nichts
     gemacht hat. Ein Feld im Fokus wird nicht angefasst, sonst springt einem
     die Eingabe unter den Fingern weg. */
  function fuellen(inp) {
    if (angefasst) return;
    if (document.activeElement === inp) return;
    if (String(inp.value == null ? '' : inp.value).trim() !== '') return;
    inp.value = '1';
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function lauf() {
    try {
      var inp = feld();
      if (!inp) return;
      beschriften(inp);
      fuellen(inp);
    } catch (e) {
      /* Eine Anzeigekorrektur darf niemals einen Kauf stoeren. */
    }
  }

  function merken(e) {
    try {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest(GRUPPE)) angefasst = true;
    } catch (x) {}
  }

  document.addEventListener('pointerdown', merken, true);
  document.addEventListener('keydown', merken, true);

  /* Erster Abschnitt: teeinblue baut sein Formular nach dem Laden auf, oft
     erst nach ein bis zwei Sekunden. Deshalb ein paar Sekunden lang im Takt
     nachsehen, danach reicht der Beobachter. */
  var start = Date.now();
  var takt = setInterval(function () {
    lauf();
    if (angefasst || Date.now() - start > FENSTER) clearInterval(takt);
  }, TAKT);
  lauf();

  /* Zweiter Abschnitt: teeinblue baut das Formular beim Wechsel von Farbe oder
     Groesse neu auf. Der Beobachter sorgt dafuer, dass die deutsche
     Beschriftung dabei nicht verloren geht. Die 1 wird auch hier nur gesetzt,
     solange der Kunde die Menge nicht angefasst hat. */
  function angestossen() {
    clearTimeout(anstossTimer);
    anstossTimer = setTimeout(lauf, 200);
  }

  function beobachten() {
    try {
      new MutationObserver(angestossen).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beobachten);
  } else {
    beobachten();
  }

  document.documentElement.style.setProperty('--cv-menge', 'on');
})();
